import React, {memo, useState, useEffect} from "../../../../../__snowpack__/pkg/react.js";
import {Input, InputNumber} from "../../../../../__snowpack__/pkg/antd.js";
import styles from "./index.module.css";
import {useIntl} from "../../../../../__snowpack__/pkg/react-intl.js";
const defaultValue = {
  min: null,
  max: null
};
const NumberIntervalInput = memo((props) => {
  const {formatMessage} = useIntl();
  const {onChange, value = defaultValue} = props;
  const [overallFocus, setOverallFocus] = useState(false);
  const [min, setMin] = useState();
  const [max, setMax] = useState();
  useEffect(() => {
    const {min: min2, max: max2} = value;
    setMin(min2);
    setMax(max2);
  }, [value]);
  useEffect(() => {
    onChange({
      min,
      max
    });
  }, [min, max]);
  return /* @__PURE__ */ React.createElement(Input.Group, {
    compact: true,
    className: styles.numberIntervalInputStyle,
    style: {width: "100%"}
  }, /* @__PURE__ */ React.createElement(InputNumber, {
    value: min ?? void 0,
    onChange: (e) => {
      setMin(e);
    },
    style: {textAlign: "center", borderRight: 0},
    placeholder: formatMessage({id: "amountMin"}),
    className: "site-input-left"
  }), /* @__PURE__ */ React.createElement(Input, {
    style: {
      width: 58,
      borderLeft: 0,
      borderRight: 0,
      pointerEvents: "none",
      textAlign: "center",
      color: "rgba(0, 0, 0, 0.45)",
      backgroundColor: "#fff"
    },
    placeholder: "~",
    disabled: true
  }), /* @__PURE__ */ React.createElement(InputNumber, {
    className: "site-input-right",
    value: max ?? void 0,
    onChange: (e) => {
      setMax(e);
    },
    style: {textAlign: "center", borderLeft: 0},
    placeholder: formatMessage({id: "amountMax"})
  }));
});
export default NumberIntervalInput;
